<template>
    <div 
        v-click-outside="onClickOutside"
        :class="[
            'devtools',
            { 'is-open': isOpen }
        ]"
        @click="onClick"
    >
        <div class="devtools-body fs-15">
            <div class="devtools-topbar">
                <header class="flex fs-21">
                    <span>
                        VM DEVTOOLS
                    </span>
                    <a 
                        class="devtools-close" 
                        @click="onClickClose"
                    />
                </header> 
            </div>
            <div class="devtools-item">
                <header class="fs-17">
                    Zaloguj się jako
                </header>
                <ul class="list list--space">
                    <li>
                        <a 
                            class="btn btn--full"
                            @click="onClickQuickLogin({ partCard1: '001', partCard2: '503202', partCard3: '011', customerNip: '5242409103' })"
                        >
                            001 503202 011<br>Katarzyna Skalska-Kordasz
                        </a>
                    </li>
                    <li>
                        <a 
                            class="btn btn--full"
                            @click="onClickQuickLogin({ partCard1: '002', partCard2: '064740', partCard3: '013', customerNip: '6291791379' })"
                        >
                            002 064740 013<br>Teresa Mostowska-Hubisz
                        </a>
                    </li>          
                </ul>
            </div>
            <div class="devtools-item">
                <header class="fs-17">
                    Nawigacja
                </header>
                <ul class="list list-inline flex">
                    <li>
                        <router-link 
                            to="/"
                            class="btn"
                        >
                            krok 1
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                            to="/zgody"
                            class="btn"
                        >
                            krok 2
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                            to="/kupon"
                            class="btn"
                        >
                            krok 3
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="devtools-item">
                <header class="fs-17">
                    Symulacja zgód
                </header>
                <ul class="list list--space">
                    <li class="flex">
                        <span>E-mail:</span>
                        <RadioGroup
                            name="devtools_email"
                            :selected="defaults.email"
                            :options="[
                                {
                                    label: 'TAK',
                                    value: '1'
                                },
                                {
                                    label: 'NIE',
                                    value: '-1'
                                }
                            ]"
                            @change="value => onChange(2, value)"
                        />
                    </li>
                    <li class="flex">
                        <span>Telefon:</span>
                        <RadioGroup
                            name="devtools_phone"
                            :selected="defaults.phone"
                            :options="[
                                {
                                    label: 'TAK',
                                    value: '1'
                                },
                                {
                                    label: 'NIE',
                                    value: '-1'
                                }
                            ]"
                            @change="value => onChange(4, value)"
                        />
                    </li>
                    <li class="flex">
                        <span>SMS:</span>
                        <RadioGroup
                            name="devtools_sms"
                            :selected="defaults.sms"
                            :options="[
                                {
                                    label: 'TAK',
                                    value: '1'
                                },
                                {
                                    label: 'NIE',
                                    value: '-1'
                                }
                            ]"
                            @change="value => onChange(6, value)"
                        />
                    </li>
                    <li class="flex">
                        <span>Gazetka:</span>
                        <RadioGroup
                            name="devtools_leaflet"
                            :selected="defaults.leaflet === true ? '1' : '0'"
                            :options="[
                                {
                                    label: 'TAK',
                                    value: '1'
                                },
                                {
                                    label: 'NIE',
                                    value: '0'
                                }
                            ]"
                            @change="value => onChange('leaflet', value)"
                        />
                    </li>
                    <li class="fs-lh-14">
                        <small v-bastards>
                            Dane Devtools resetują się podczas logowania użytkownika i odświeżania strony.
                        </small>
                    </li>
                </ul>
            </div>
        </div>
        <div class="devtools-icon fs-21">
            VM
        </div>
    </div>
</template>

<script>

import RadioGroup from '@/components/form/RadioGroup'

export default {
    components: {
        RadioGroup
    },

    data () {
        return {
            isOpen: false,
            isBusy: false,
            defaults: {
                email: '',
                phone: '',
                sms: '',
                leaflet: ''
            }
        }
    },

    mounted() {
        this.defaults = {
            email: '',
            phone: '',
            sms: '',
            leaflet: false
        }
    },

    watch: {
        isBusy(value) {
            if (value === true) {
                this.$store.dispatch('siteLoader/open')
            }
            else {
                this.$store.dispatch('siteLoader/close')
            }
        }
    },

    methods: {
        onClickOutside() {
            this.close()
        },

        onClickClose() {
            this.close()
        },

        close() {
            if (this.isOpen) {
                this.isOpen = false
            }
        },

        onClick(e) {
            if (e.target.className !== 'devtools-close' && !this.isOpen) {
                this.isOpen = true
            }
        },

        onClickQuickLogin(params) {
            this.isBusy = true

            this.$store.dispatch('devtools/login', params)
                .then(() => { 
                    this.isBusy = false

                    this.$router.push({ name: 'zgody' }) 
                })
                .catch(e => {
                    this.isBusy = false

                    console.log(e)
                })
        },

        onChange(item, value) {
            if (item === 'leaflet') {
                this.$store.dispatch('consentsResolver/setLeafletConsent', value === '1' ? null : false)
            }
            else {
                this.$store.dispatch('consentsResolver/updateStructure', { type: item, value })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.devtools {
    @include transition(all 0s ease .3s);
    cursor: pointer;
    overflow: hidden;
    position: fixed;
    bottom: 50px;
    right: 50px;
    width: 60px;
    height: 60px;
    min-height: 60px;
    z-index: 3019;

    &:before {
        content: '';
        @include size(60px);
        @include border-circle();
        @include transition(.3s);
        background-color: $color-default;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: -1;
    }

    &-icon {
        @include transition(all .1s ease .3s);
        color: $color-default-contrast;
        position: absolute;
        top: 16px;
        left: 16px;
    }

    &-body {
        @include hide();
        @include transition(all .1s ease 0s);
        color: $color-default-contrast;
        padding: 0 0 20px;
    }

    &-topbar {
        background-color: $color-vm;
        color: $color-default;
        padding: 25px 30px 23px;
    }

    &-close {
        @include size(24px);
        cursor: pointer;
        position: relative;

        &:before {
            content: '';
            @include hide();
            @include border-circle();
            @include position-cover(-10px);
            @include transform(scale(.618));
            @include transition(.1s);
            background-color: $color-default-contrast;
        }

        &:after {
            content: '×';
            @include transition(.1s);
            position: absolute;
            font-size: 29px;
            top: -11px;
            left: 4px;
        }

        &:hover {
            &:before {
                @include show();
                @include transform-none();
            }

            &:after {
                @include transform(translateY(-4px) scale(2));
            }
        }
    }

    &-item {
        padding: 12px 30px 0;

        & + & {
            margin-top: .5em;
        }

        header {
            padding: 0 0 12px;
        }

        .btn {
            @include border-radius(3px);
            @include transition(.1s);
            background-color: $color-vm;
            cursor: pointer;
            text-align: center;
            padding: 5px 30px;

            &--full {
                width: 100%;
            }

            &:hover {
                background-color: $color-vm-light;
            }
        }
    }

    &:hover {
        &:not(.is-open) {
            &:before {
                background-color: $color-default-light;
            }
        }
    }

    &.is-open {
        @include transition(all 0s ease 0s);
        cursor: auto;
        width: 400px;
        min-height: 580px;

        &:before {
            @include transform(scale(25));
        }
    }

    &.is-open & {
        &-icon {
            @include transition(all 0s ease 0s);
            @include hide();
        }

        &-body {
            @include show();
            @include transition(all .15s ease .15s);
        }
    }
}
</style>
